import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple password check (in production, use proper authentication)
    if (password === 'admin123' || password === 'admin') {
      localStorage.setItem('adminAuthenticated', 'true');
      navigate('/admin/panel');
    } else {
      setError('كلمة المرور غير صحيحة');
    }
  };

  return (
    <div className="admin-login-page">
      <div className="login-container">
        <div className="login-card">
          <h1>تسجيل الدخول إلى لوحة التحكم</h1>
          <p>يرجى إدخال كلمة المرور للوصول إلى لوحة التحكم</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">كلمة المرور</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                placeholder="أدخل كلمة المرور"
                required
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="btn btn-primary btn-block">
              تسجيل الدخول
            </button>
          </form>
          <div className="login-note">
            <small>ملاحظة: كلمة المرور الافتراضية هي "admin123" أو "admin"</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

